<template lang="pug">
  .message--bar(:class="type")
    .row.no-gutters
      .col-auto(v-if="withIcon")
        .message--bar-icon
          font-awesome-icon(:icon="icon")
      .col
        slot
</template>




<script>
  export default {
    name: 'MessageBar',

    props: {
      type: {
        type: String,
        default: 'neutral',
      },
      withIcon: {
        type: Boolean,
        default: true,
      },
      icon: {
        type: String,
        default: 'info-circle',
      },
    },
  }
</script>




<style lang="scss">
  .message--bar {
    padding: 10px 14px 9px;
    border-radius: 4px;
    font-size: 0.875rem;

    &.neutral {
      background: #f5f5f5;
      border: 1px solid #eee;
      color: #666;
    }

    &.warning {
      color: #664D03;
      background: #FFF9E6;
      border: 1px solid #FFECB5;
    }

    &.success {
      color: #036636;
      background: #E7FEF3;
      border: 1px solid #C0F4DB;
    }

    &.error {
      color: #660303;
      background: #FFE6E6;
      border: 1px solid #FFB5B5;
    }

    .message--bar-icon {
      margin-right: 11px;
      position: relative;
      top: 1px;
    }
  }
</style>
